var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.24,
    height: 23.2,
    viewBox: "0 0 16.24 23.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.134,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e5bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d60f5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M15.62,3A8.114,8.114,0,0,0,7.5,11.12c0,6.09,8.12,15.08,8.12,15.08s8.12-8.99,8.12-15.08A8.114,8.114,0,0,0,15.62,3Zm0,11.02a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,15.62,14.02Z",
    transform: "translate(-7.5 -3)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f3f7aea5c33f13c95537b08408dbd850.svg";
export { ForwardRef as ReactComponent };